import config from '../internetConfig';
import utils from '../../utils';
import axios from 'axios';
var ciosData = [];
var cioMatches = [];

const synonyms = {
	center: ['ctr', 'cent'],
	centers: ['ctrs', 'cents'],
	management: ['mgt', 'mgmt'],
	association: ['assoc'],
	operations: ['ops'],
	statistics: ['stats'],
	services: ['svcs'],
	service: ['svc'],
	institute: ['inst'],
	technology: ['tech'],
	division: ['div'],
	director: ['dir'],
	laboratory: ['lab'],
	national: ['ntl'],
};

const boostAmount = utils.toNumber(config.ciosBoost || 2);

const load = new Promise((resolve) => {
	if (!config.ciosURL) {
		return resolve(true);
	}

	// if cios URL is set, load the cios data
	axios
		.get(config.ciosURL)
		.then((response) => {
			ciosData = utils.toArray(response.data);
			// get raw names stripped of filler words for each
			ciosData.forEach((cio, i) => {
				if (cio.name) {
					ciosData[i].rawName = utils.stripFillerWords(cio.name);
				}
			});
			resolve();
		})
		.catch((error) => {
			config.debug && console.error('Search: CIOs Error:', error);
			resolve();
		});
});

const queryFilter = (query, searchParts) => {
	if (!ciosData.length) {
		return query;
	}
	cioMatches = []; // reset cioMatches
	let searchTerm = utils.stripFillerWords(utils.maybeJoin(searchParts.query, ' '));
	let boosts = [];
	for (var term in synonyms) {
		var list = synonyms[term];
		list.forEach((synonym) => {
			searchTerm = searchTerm.replace(new RegExp('\\b' + synonym + '\\.?\\b', 'ig'), ' ' + term + ' ');
		});
	}
	searchTerm = searchTerm.replace(/\s\s+/g, ' ');
	ciosData.forEach((cio) => {
		let name = cio.name;
		let rawName = cio.rawName;
		let abbr = cio.abbr;
		let regEx;
		if (name && rawName) {
			regEx = new RegExp(rawName, 'i');
			if (searchTerm.match(regEx)) {
				boosts.push('content:"' + utils.cleanTerm(name) + '"^' + boostAmount);
				cioMatches.push(cio);
			}
		}
		if (abbr) {
			// wrap with spaces for a whole word match
			regEx = new RegExp('\\b' + abbr + '\\b', 'i');
			if (searchTerm.match(regEx)) {
				boosts.push('content:"' + utils.cleanTerm(abbr) + '"^' + boostAmount);
				cioMatches.push(cio);
			}
		}
	});
	if (boosts.length) {
		query.bq = utils.toArray( query.bq || [] );
		query.bq = query.bq.concat(boosts);
	}
	return query;
};

const getMatches = () => {
	return cioMatches;
};

export default { load, queryFilter, getMatches };
